export const CURRENT_CONFIG = {

  // license
  appId: '156878', // You need to go to the development website to apply.
  appKey: '8e5bc70f6548c0bf0d8bacc882f6a85', // You need to go to the development website to apply.
  appLicense: 'k3zNyT0bUy7pfirdZrWN8W+zZGAjSZYHu0FhXAOkL2udqJVoiyzIFRjDE1IFloqhYt9ibaLUpr+J8+r7QUA/cEmQRfUCJJUtK47//Smy0hgyyTv3jfCpK4/vN4EWwFK36g+d13UGE3U/xoqDhMR5ZS7sAUkHATKP7qfsT3ceHiY=', // You need to go to the development website to apply.

  // http
  baseURL: 'https://cloud-api.twinlogic.gr:6789/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'ws://cloud-api.twinlogic.gr:36789/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmps://stream-vg-1.twinlogic.gr:1936/live', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'aaaaa',
  rtspPassword: 'aaaa',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
